import cx from 'classnames';
import moment, { Moment } from 'moment-timezone';
import Calendar from 'rc-calendar';
import enUS from 'rc-calendar/lib/locale/en_US';
import Picker from 'rc-calendar/lib/Picker';
import React, { FocusEvent } from 'react';

import CalendarIcon from '../Icons/Calendar';
import ChevronSmallDown from '../Icons/ChevronS1Down';
import TextInput from '../TextInput';
import IconButton from '../IconButton';

import styles from './DateInput.module.scss';
import 'rc-calendar/assets/index.css';

export interface Props {
  calendarClassName?: string;
  inputClassName?: Parameters<typeof cx>[0];
  className?: Parameters<typeof cx>[0];
  defaultValue: Moment | null;
  disabledDate: (d?: Moment) => boolean;
  errorMessage?: string;
  id: string;
  label?: string;
  name?: string;
  onBlur?: (event: FocusEvent<HTMLInputElement> | null) => void;
  onChange: (v: Moment) => void;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
  pickerClassName?: Parameters<typeof cx>[0];
  placeholder?: string;
  value: Moment | null;
}

export const DateInput: React.FC<Props> = props => {
  const inputRef = React.useRef(null);
  const momentValue =
    props.value != null && moment(props.value).isValid()
      ? moment(props.value)
      : null;

  return (
    <Picker
      {...props}
      dropdownClassName={cx(styles.wrapper, props.pickerClassName)}
      calendar={
        <Calendar
          className={props.calendarClassName}
          locale={enUS}
          disabledDate={props.disabledDate}
          showDateInput={false}
          showToday={false}
          style={{ top: '3px' }}
        />
      }
      value={momentValue}
      getCalendarContainer={() => inputRef.current}
      onOpenChange={(open: boolean) => {
        // Call blur to touch the input field on close
        if (!open && props.onBlur != null) {
          props.onBlur(null);
        }
      }}
    >
      {(pickerProps: { value: Moment | null }) => (
        <div className={cx(props.className)}>
          <TextInput
            className={cx(styles.dateInput, props.inputClassName)}
            prefix={() => <CalendarIcon />}
            iconButtons={[
              <IconButton
                accessibilityLabel='Open date picker'
                icon={<ChevronSmallDown />}
              />,
            ]}
            id={props.id}
            name={props.name}
            placeholder={props.placeholder}
            label={props.label || ''}
            errorMessage={props.errorMessage}
            onChange={() => null}
            value={
              (pickerProps.value &&
                pickerProps.value.format &&
                pickerProps.value.format('YYYY-MM-DD')) ||
              ''
            }
          >
            <span ref={inputRef}></span>
          </TextInput>
        </div>
      )}
    </Picker>
  );
};

DateInput.displayName = 'DateInput';
export default DateInput;
export { styles };
